import { useEffect, useState } from "react";
import RealTimeService from "../../../../../realtime/RealTimeService";
import { IAlert } from "../models/IAlert";

export const useAlert = () => {
  const [data, setData] = useState<IAlert | null>(null);

  useEffect(() => {
    const subscription = RealTimeService.subscribe("*", "ALERT", (message) => {
      setData(message.notificationData);
    });
    return subscription.unsubscribe;
  }, []);

  return data;
};
